import { styled } from "@woba/ds-web";

export const InfoLabelContainer = styled("div", {
  borderStyle: "solid",
  borderWidth: "1px",
  borderColor: "$neutral-200",
  borderRadius: "$sm",

  padding: "$space-02 6px",

  fontSize: "$sm",
  textTransform: "uppercase",
  color: "$neutral-700",
  fontWeight: 500,
  fontStyle: "normal",

  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  lineHeight: "0.5rem",
});
